import { render, staticRenderFns } from "./NumericKeyboard.vue?vue&type=template&id=31b7116c&scoped=true"
import script from "./NumericKeyboard.vue?vue&type=script&lang=js"
export * from "./NumericKeyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7116c",
  null
  
)

export default component.exports